var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Container',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-4 col-xl-3 m-auto"},[_c('MoreLinks')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }